/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .instant-cell[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   .instant-cell-loader[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;font-size:3.3333333333em;width:306px;height:306px}"];
export { styles as styles };
